import React, { useState } from "react";
import {
  Typography,
  Button,
  Modal,
  Box,
  IconButton,
  Paper,
  Tooltip
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { variableOptions } from "../../../common/constants/scheduleDataConstants";
import { ContentCopy, Check } from "@mui/icons-material";

const VariableModal = ({ open, onClose }) => {
  const [copiedId, setCopiedId] = useState(null);
  const handleCopy = async (item) => {
    try {
      await navigator.clipboard.writeText(item.name);
      setCopiedId(item.id);
      setTimeout(() => setCopiedId(null), 1500);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <div>
      <Modal open={open} onClose={onClose}>
        <Box
          sx={{
            width: 550,
            margin: "auto",
            padding: 3,
            marginTop: 8,
            backgroundColor: "white",
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            Variables
          </Typography>

          {/* Data Rows */}
          <Box sx={{ maxHeight: "50vh", overflowY: "auto", pr: 1 }}>
            {variableOptions.map((item) => (
              <Box key={item.id} component={Paper} sx={{ p: 1, mb: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={1}>
                    <Tooltip title={copiedId === item.id ? "Copied" : "Copy"} placement="top">
                      <IconButton
                        size="small"
                        sx={{ p: 1 }}
                        onClick={() => handleCopy(item)}
                      >
                        {copiedId === item.id ? <Check /> : <ContentCopy />}
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item size="grow">
                    <Typography>{item.name}</Typography>
                  </Grid>
                  <Grid item size="grow">
                    <Typography>{item.description}</Typography>
                  </Grid>
                </Grid>
              </Box>
            ))}
          </Box>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default VariableModal;
